/**
 * @param {angular.$scope} $scope
 * @param {Object} messageResolve
 * @param {angular.Service} AppointmentModal
 * @constructor
 */
var SMSCtrl = function($scope, messageResolve, AppointmentModal) {
  this.AppointmentModal_ = AppointmentModal;

  $scope.setMessage(messageResolve);

  $scope.message = messageResolve;
};

/**
 * @param {Object} appointment
 */
SMSCtrl.prototype.openAppointment = function(appointment) {
  appointment.start = new Date(appointment.start);
  appointment.end = new Date(appointment.end);

  switch (appointment.type) {
    case 'customer':
      this.AppointmentModal_.open(appointment);
      break;

    case 'course':
      this.AppointmentModal_.open(appointment);
      break;

    default:
      this.AppointmentModal_.open(appointment);
      break;
  }
};

module.exports = SMSCtrl;



// WEBPACK FOOTER //
// ./src/app/modules/message/types/SMSCtrl.js